const mediaQueryMd = window.matchMedia('(min-width: 768px)');
const mediaQueryLg = window.matchMedia('(min-width: 1024px)');



import { smoothScroll } from "./include/module";
smoothScroll();

import { showYouTubeModal } from "./include/module";
showYouTubeModal();



const scrollAnimation = () => {
  let controller = new ScrollMagic.Controller();
  let sceneStory;
  let sceneCharaJunnaIllust, sceneCharaJunnaBody, sceneCharaJunnaName;
  let sceneCharaNanaIllust, sceneCharaNanaBody, sceneCharaNanaName;
  let sceneCharaFutabaIllust, sceneCharaFutabaBody, sceneCharaFutabaName;
  let sceneCharaKaorukoIllust, sceneCharaKaorukoBody, sceneCharaKaorukoName;
  let offsetStoryIllust = 0;
  let offsetCharaIllust = 0;
  let offsetCharaBody = 0;
  let offsetCharaName = 0;


  //オフセット設定
  function animationOffsetSetting(e) {
    if( e.matches ) {
      offsetStoryIllust = 300;
      offsetCharaIllust = 100;
      offsetCharaBody = 100;
      offsetCharaName = 50;

    } else {
      offsetStoryIllust = 150;
      offsetCharaIllust = 50;
      offsetCharaBody = 0;
      offsetCharaName = 30;
    }
  }
  mediaQueryMd.addListener(animationOffsetSetting);
  animationOffsetSetting(mediaQueryMd);


  function isAnimated(targetElem) {
    if( !$(targetElem).hasClass('is-animated') ) {
      $(targetElem).addClass('is-animated');
    }
  }


  //オリジナルストーリー　メモワール
  sceneStory = new ScrollMagic.Scene({
    triggerElement: '.idx-Section_Story .idx-Section_Body',
    triggerHook: 'onEnter',
    reverse: false,
    offset: offsetStoryIllust,
  })
  .on('enter', function() {
    $('.idx-Section_Story .illust.karen').addClass('is-animated');
    $('.idx-Section_Story .illust.chika').addClass('is-animated');
    $('.idx-Section_Story .illust.mahiru_hikari').addClass('is-animated');
  })
  // .addIndicators()
  .addTo(controller);


  //コラボ舞台少女　星見純那
  sceneCharaJunnaIllust = new ScrollMagic.Scene({
    triggerElement: '.chara_wrapper.junna .illust',
    triggerHook: 'onEnter',
    reverse: false,
    offset: offsetCharaIllust,
  })
  .on('enter', function() {
    $('.chara_wrapper.junna .illust').addClass('is-animated');
  })
  // .addIndicators()
  .addTo(controller);

  sceneCharaJunnaBody = new ScrollMagic.Scene({
    triggerElement: '.chara_wrapper.junna .body',
    triggerHook: 'onEnter',
    reverse: false,
    offset: offsetCharaBody,
  })
  .on('enter', function() {
    $('.chara_wrapper.junna .body').addClass('animating');

    setTimeout(function() {
      $('.chara_wrapper.junna .body').removeClass('animating').addClass('is-animated');
    }, 900);
  })
  // .addIndicators()
  .addTo(controller);

  sceneCharaJunnaName = new ScrollMagic.Scene({
    triggerElement: '.chara_wrapper.junna .name',
    triggerHook: 'onEnter',
    reverse: false,
    offset: offsetCharaName,
  })
  .on('enter', function() {
    $('.chara_wrapper.junna .name').addClass('is-animated');
  })
  // .addIndicators()
  .addTo(controller);


  //コラボ舞台少女　大場なな
  sceneCharaNanaIllust = new ScrollMagic.Scene({
    triggerElement: '.chara_wrapper.nana .illust',
    triggerHook: 'onEnter',
    reverse: false,
    offset: offsetCharaIllust,
  })
  .on('enter', function() {
    $('.chara_wrapper.nana .illust').addClass('is-animated');
  })
  // .addIndicators()
  .addTo(controller);

  sceneCharaNanaBody = new ScrollMagic.Scene({
    triggerElement: '.chara_wrapper.nana .body',
    triggerHook: 'onEnter',
    reverse: false,
    offset: offsetCharaBody,
  })
  .on('enter', function() {
    $('.chara_wrapper.nana .body').addClass('animating');

    setTimeout(function() {
      $('.chara_wrapper.nana .body').removeClass('animating').addClass('is-animated');
    }, 900);
  })
  // .addIndicators()
  .addTo(controller);

  sceneCharaNanaName = new ScrollMagic.Scene({
    triggerElement: '.chara_wrapper.nana .name',
    triggerHook: 'onEnter',
    reverse: false,
    offset: offsetCharaName,
  })
  .on('enter', function() {
    $('.chara_wrapper.nana .name').addClass('is-animated');
  })
  // .addIndicators()
  .addTo(controller);


  //コラボ舞台少女　石動双葉
  sceneCharaFutabaIllust = new ScrollMagic.Scene({
    triggerElement: '.chara_wrapper.futaba .illust',
    triggerHook: 'onEnter',
    reverse: false,
    offset: offsetCharaIllust,
  })
  .on('enter', function() {
    $('.chara_wrapper.futaba .illust').addClass('is-animated');
  })
  // .addIndicators()
  .addTo(controller);

  sceneCharaFutabaBody = new ScrollMagic.Scene({
    triggerElement: '.chara_wrapper.futaba .body',
    triggerHook: 'onEnter',
    reverse: false,
    offset: offsetCharaBody,
  })
  .on('enter', function() {
    $('.chara_wrapper.futaba .body').addClass('animating');

    setTimeout(function() {
      $('.chara_wrapper.futaba .body').removeClass('animating').addClass('is-animated');
    }, 900);
  })
  // .addIndicators()
  .addTo(controller);

  sceneCharaFutabaName = new ScrollMagic.Scene({
    triggerElement: '.chara_wrapper.futaba .name',
    triggerHook: 'onEnter',
    reverse: false,
    offset: offsetCharaName,
  })
  .on('enter', function() {
    $('.chara_wrapper.futaba .name').addClass('is-animated');
  })
  // .addIndicators()
  .addTo(controller);


  //コラボ舞台少女　花柳香子
  sceneCharaKaorukoIllust = new ScrollMagic.Scene({
    triggerElement: '.chara_wrapper.kaoruko .illust',
    triggerHook: 'onEnter',
    reverse: false,
    offset: offsetCharaIllust,
  })
  .on('enter', function() {
    $('.chara_wrapper.kaoruko .illust').addClass('is-animated');
  })
  // .addIndicators()
  .addTo(controller);

  sceneCharaKaorukoBody = new ScrollMagic.Scene({
    triggerElement: '.chara_wrapper.kaoruko .body',
    triggerHook: 'onEnter',
    reverse: false,
    offset: offsetCharaBody,
  })
  .on('enter', function() {
    $('.chara_wrapper.kaoruko .body').addClass('animating');

    setTimeout(function() {
      $('.chara_wrapper.kaoruko .body').removeClass('animating').addClass('is-animated');
    }, 900);
  })
  // .addIndicators()
  .addTo(controller);

  sceneCharaKaorukoName = new ScrollMagic.Scene({
    triggerElement: '.chara_wrapper.kaoruko .name',
    triggerHook: 'onEnter',
    reverse: false,
    offset: offsetCharaName,
  })
  .on('enter', function() {
    $('.chara_wrapper.kaoruko .name').addClass('is-animated');
  })
  // .addIndicators()
  .addTo(controller);



  let windowScrollPos = 0;

  function scrollAnimation(scrollPos) {
    $('.js-fade_up').each(function() {
      let targetElem = $(this);
      let targetElemOffset = $(this).offset().top;

      if( scrollPos + window.innerHeight > targetElemOffset ) {
        targetElem.addClass('is-animated');
      }
    });
  }

  $(window).on('load scroll', function() {
    windowScrollPos = $(window).scrollTop();

    scrollAnimation(windowScrollPos);
  });
}
scrollAnimation();



// WEBPACK FOOTER //
// ./src/assets/js/script.js